import * as React from "react";
import { forwardRef } from "react";
const SvgTwoFifthBar = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 8, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#32AF04", d: "M3.883.275H.409v7.036h3.474zM8.514.275H5.04v7.036h3.474z" }), /* @__PURE__ */ React.createElement("path", { fill: "#D7D8DC", d: "M13.145.277H9.67v7.035h3.474zM17.777.275h-3.474v7.036h3.474z" }));
const ForwardRef = forwardRef(SvgTwoFifthBar);
export { ForwardRef as ReactComponent };
